/**
 * 用户相关接口
 */
import http, { BASE_NAME } from './index.js';

/**
 * 获取小程序二维码
 */
export async function getQrcode() {
  try {
    const data = await http.get(`${BASE_NAME}/member/social-user/state/create`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 轮循环查询登录状态
 */
export async function checkLoginStatus(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/social-user/state/get`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 使用手机 + 验证码登录
 */
export async function smsLogin(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/auth/sms-login`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 使用手机 + 密码登录
 */
export async function authLogin(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/auth/login`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 社交授权的跳转
 * @param {object} params - 参数
 * @param {number} params.type - 社交类型
 * @param {string} params.redirectUri - 回调路径
 */
export async function getSocialAuthRedirect(params) {
  try {
    const data = await http.get(`${BASE_NAME}/member/auth/social-auth-redirect`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 社交快捷登录，使用 code 授权码
 * @param {object} data - 登录参数
 * @param {number} data.type - 社交平台的类型
 * @param {string} data.code - 授权码
 * @param {string} data.state - state
 */
export async function socialLogin(data) {
  try {
    const result = await http.post(`${BASE_NAME}/member/auth/social-login`, data);

    return result;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取企业微信JS-SDK配置
 * @param {string} url - 当前页面的URL
 */
export async function getWechatCpJsapiSignature(url) {
  try {
    const data = await http.post(`${BASE_NAME}/member/auth/create-weixin-cp-jsapi-signature?url=${url}`);

    return data;
  } catch (error) {
    console.error('获取企业微信JS-SDK配置失败:', error);
    throw error;
  }
}

/**
 * 刷新令牌
 */
export async function refreshToken(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/auth/refresh-token?refreshToken=${value}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 发送手机验证码
 * SmsSceneEnum: 1.登录 2.修改手机 3.修改密码 4.忘记密码 21.手机号登录
 */
export async function sendSmsCode(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/auth/send-sms-code`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得基本信息
 */
export async function memberUserGet(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/user/get`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 修改用户密码
 */
export async function memberUserUpdatePassword(value) {
  try {
    const data = await http.put(`${BASE_NAME}/member/user/update-password`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 修改基本信息
 */
export async function memberUserUpdate(value) {
  try {
    const data = await http.put(`${BASE_NAME}/member/user/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 修改用户头像
 */
export async function memberUserUpdateAvatar(value) {
  try {
    const data = await http.put(`${BASE_NAME}/member/user/update-avatar`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 修改用户手机
 */
export async function memberUserUpdateMobile(value) {
  try {
    const data = await http.put(`${BASE_NAME}/member/user/update-mobile`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取高校数据
 */
export async function getSchoolTree() {
  try {
    const data = await http.get(`${BASE_NAME}/system/university/list-all-name`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 身份认证
 */
export async function authIdentity(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/real-name-auth/auth`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 角色认证
 */
export async function authRole(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/role-auth/auth`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取角色认证信息
 */
export async function getRoleAuth(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/role-auth/get`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 企业角色认证
 */
export async function authEnterprise(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/enterprise-auth/auth`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 通过名称模糊匹配获取企业信息
 */
export async function searchByName(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/enterprise/list-by-keyword`, { params: value });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 根据企业名称获取企业信息
 */
export async function getEnterpriseByName(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/enterprise/get-by-keyword`, { params: value });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 根据企业名称获取企业信息
 */
export async function createEnterprise(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/enterprise/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取学校
 */
export async function getSchool(value) {
  try {
    const data = await http.get(`${BASE_NAME}/system/university/list`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 企业角色认证详情
 */
export async function authEnterpriseDetails(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/enterprise/get`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取当前用户的最新站内信列表
 */
export async function getLatestMessage(value) {
  try {
    const data = await http.get(`${BASE_NAME}/system/notify-message/get-unread-list`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得我的站内信分页
 */
export async function getMyMessage(value) {
  try {
    const data = await http.get(`${BASE_NAME}/system/notify-message/my-page`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 站内信息全部已读
 */
export async function readAllMessage(value) {
  try {
    const data = await http.put(`${BASE_NAME}/system/notify-message/update-all-read`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得当前用户的未读站内信数量
 */
export async function getUnreadMessageCount(value) {
  try {
    const data = await http.get(`${BASE_NAME}/system/notify-message/get-unread-count`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 标记当前站内信为已读
 */
export async function readMessage(value) {
  try {
    const data = await http.put(`${BASE_NAME}/system/notify-message/update-read?ids=${value}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/** 我的收藏 */

/**
 * 获得收藏信息分页
 */
export async function getCollectList(value) {
  try {
    const data = await http.get(`${BASE_NAME}/community/collect/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得会员福利分页
 */
export async function getWealPage(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/weal/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得会员优惠券列表
 */
export async function getCouponUsageList(params) {
  try {
    const data = await http.get(`${BASE_NAME}/trade/coupon-usage/page`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得会员优惠券分页
 */
export async function deleteCouponUsage(id) {
  try {
    const data = await http.delete(`${BASE_NAME}/trade/coupon-usage/delete?id=${id}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 优惠卷数量
export async function getCouponUsageGroupCount(queryVal) {
  try {
    const data = await http.get(`${BASE_NAME}/trade/coupon-usage/group-count`, {
      params: queryVal,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得apvg任务分页
 */
export async function getApvgTaskPage(value) {
  try {
    const data = await http.get(`${BASE_NAME}/aigc/apvg-task/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 获取视频生成任务数据
export async function getApvgTaskGet(params) {
  try {
    const data = await http.get(`${BASE_NAME}/aigc/apvg-task/info`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 使用会员福利（课程福利）
 */
export async function postMemberWealUse(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/weal/use`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取我的活动列表
 */
export async function getMyActivityList(value) {
  try {
    const data = await http.get(`${BASE_NAME}/industry/internship-application/my-list`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取我的报名竞赛
 */
export async function getMyApplicantList(value) {
  try {
    const data = await http.get(`${BASE_NAME}/contest/applicant/my-list`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 随机分配竞赛阶段考试方案
 */
export async function createApplicantStageExam(value) {
  try {
    const data = await http.post(`${BASE_NAME}/contest/applicant-stage-exam/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得竞赛阶段报名人抽取方案信息
 */
export async function getApplicantStageExamInfo(value) {
  try {
    const data = await http.get(`${BASE_NAME}/contest/applicant-stage-exam/get`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 更新开始考试时间
 */
export async function updateStartExamTime(id) {
  try {
    const data = await http.put(`${BASE_NAME}/contest/applicant-stage-exam/update?id=${id}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 竞赛:获取考生是否完成考试
 */
export async function getContestExamInfo(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/tt-auth/get-contest-exam-info`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 查询单课列表
 */
export async function getSingleCourseList(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course-video/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取详情
 */
export async function getSingleCourseDetails(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course-video/get`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 新增单课
 */
export async function createSingleCourse(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course-video/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 编辑单课
 */
export async function updateSingleCourse(value) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course-video/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 删除单课
 */
export async function deleteSingleCourse(value) {
  try {
    const data = await http.delete(`${BASE_NAME}/school/course-video/delete`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 上架单课
 */
export async function putSingleCourse(id) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course-video/up?id=${id}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 下架单课
 */
export async function downSingleCourse(id) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course-video/down?id=${id}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 查询课程列表
 */
export async function getCourseList(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/my-page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取课程详情
 */
export async function getCourseDetails(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/detail`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取课程内容
 */
export async function getCourseContent(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/content`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 课程目录列表
 */
export async function getCourseContents(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/contents/get`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 新增课程目录
 */
export async function createCourseContents(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course/contents/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 编辑课程目录
 */
export async function updateCourseContents(value) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/contents/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 删除课程目录
 */
export async function deleteCourseContents(value) {
  try {
    const data = await http.delete(`${BASE_NAME}/school/course/contents/delete`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 更新排序
 */
export async function updateCourseContentsSort(value) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/contents/sort`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 新增课程
 */
export async function createCourse(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 编辑课程
 */
export async function updateCourse(value) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 删除课程
 */
export async function deleteCourse(value) {
  try {
    const data = await http.delete(`${BASE_NAME}/school/course/delete`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 上架课程
 */
export async function putCourse(id) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/up?id=${id}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 下架课程
 */
export async function downCourse(id) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/down?id=${id}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 查询课程讲义列表
 */
export async function getCourseDocumentsPage(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course/documents/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 查询课程实训列表
 */
export async function getCourseTrainingPage(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course-training/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取课程实训详情
 */
export async function getCourseTrainingDetail(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/course-training/get`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 新增课程实训
 */
export async function addCourseTraining(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course-training/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 *  编辑课程实训
 */
export async function updateCourseTraining(value) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course-training/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 删除课程实训
 */
export async function deleteCourseTraining(id) {
  try {
    const data = await http.delete(`${BASE_NAME}/school/course-training/delete?id=${id}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 删除课程讲义
 */
export async function deleteCourseDocuments(id) {
  try {
    const data = await http.delete(`${BASE_NAME}/school/course/documents/delete?id=${id}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 新增课程讲义
 */
export async function createCourseDocumentsApi(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course/documents/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 修改课程讲义
 */
export async function updateCourseDocumentsApi(value) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/documents/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获取考试列表
 */
export async function getExaminationPaperPage(value) {
  try {
    const data = await http.get(`${BASE_NAME}/school/examination-paper/page`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 新增课程考试
 */
export async function createCourseExaminationApi(value) {
  try {
    const data = await http.post(`${BASE_NAME}/school/course/exam/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 修改课程考试
 */
export async function updateCourseExaminationApi(value) {
  try {
    const data = await http.put(`${BASE_NAME}/school/course/exam/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 删除课程考试
 */
export async function deleteCourseExaminationApi(id) {
  try {
    const data = await http.delete(`${BASE_NAME}/school/course/exam/delete?id=${id}`);

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 查询题库列表
export async function getQuestionLibraryPage(params) {
  return await http.get(`${BASE_NAME}/school/question-library/page`, { params });
}

// 查询题库详情
export async function getQuestionLibrary(id) {
  return await http.get(`${BASE_NAME}/school/question-library/get?id=${id}`);
}

// 新增题库
export async function createQuestionLibrary(data) {
  return await http.post(`${BASE_NAME}/school/question-library/create`, data);
}

// 修改题库
export async function updateQuestionLibrary(data) {
  return await http.put(`${BASE_NAME}/school/question-library/update`, data);
}

// 删除题库
export async function deleteQuestionLibrary(id) {
  return await http.delete(`${BASE_NAME}/school/question-library/delete?id=${id}`);
}

// 所有章节
export async function questionChapterList() {
  return await http.get(`${BASE_NAME}/school/question-chapter/list`);
}

// 查询试卷详情
export async function getExaminationPaper(id) {
  return await http.get(`${BASE_NAME}/school/examination-paper/get?id=${id}`);
}

// 新增试卷
export async function createExaminationPaper(data) {
  return await http.post(`${BASE_NAME}/school/examination-paper/create`, data);
}

// 修改试卷
export async function updateExaminationPaper(data) {
  return await http.put(`${BASE_NAME}/school/examination-paper/update`, data);
}

// 删除试卷
export async function deleteExaminationPaper(id) {
  return await http.delete(`${BASE_NAME}/school/examination-paper/delete?id=${id}`);
}

// 上架课程
export async function CourseUp(id) {
  return await http.put(`${BASE_NAME}/school/course/up?id=${id}`);
}

// 下架课程
export async function CourseDown(id) {
  return await http.put(`${BASE_NAME}/school/course/down?id=${id}`);
}

// 获得试卷题目
export async function examinationQuestionsGet(id) {
  return await http.get(`${BASE_NAME}/school/examination-paper/paper-detail?paperId=${id}`);
}

// 创建试卷题目
export async function examinationQuestionsCreate(data) {
  return await http.post(`${BASE_NAME}/school/examination-questions/create`, data);
}

// 更新试卷题目
export async function examinationQuestionsUpdate(data) {
  return await http.put(`${BASE_NAME}/school/examination-questions/update`, data);
}

// 导入试题
export async function questionLibraryImportFile(data) {
  return await http.post(`${BASE_NAME}/school/question-library/import`, data);
}

// 导入试卷
export async function examinationQuestionsImportFile(data) {
  return await http.post(`${BASE_NAME}/school/examination-questions/import`, data);
}

// 试题排序
export async function examinationQuestionsSortUpdate(data) {
  return await http.put(`${BASE_NAME}/school/examination-questions/sort`, data);
}

// 删除试卷
export async function deleteExaminationDelete(paperId, questionId) {
  return await http.delete(`${BASE_NAME}/school/examination-questions/delete?paperId=${paperId}&questionId=${questionId}`);
}

// 删除试卷(整个)
export async function deleteExaminationDeleteAll(paperId, questionType) {
  return await http.delete(
    `${BASE_NAME}/school/examination-questions/deleteByType?paperId=${paperId}&questionType=${questionType}`,
  );
}

// 课程提交审核
export async function courseSubmitAudit(values) {
  return await http.put(`${BASE_NAME}/school/course/submit-audit?id=${values.id}`);
}

// 课程收益
export async function courseIncome(params) {
  return await http.get(`${BASE_NAME}/school/my-course/my-income`, { params });
}

// 资源授权企业列表分页
export async function resourceEnterprisePage(params) {
  try {
    const data = await http.get(`${BASE_NAME}/member/resource-authorization/page`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 下载企业列表
export async function downloadResource(value) {
  return await http.get(`${BASE_NAME}/member/resource-authorization/export-excel`, {
    params: value,
    responseType: 'blob',
  });
}

// 下载订单
export async function downloadOrder(value) {
  return await http.get(`${BASE_NAME}/trade/order/export-excel`, {
    params: value,
    responseType: 'blob',
  });
}

// 获取准考证信息
export async function getTicket(value) {
  try {
    const data = await http.get(`${BASE_NAME}/contest/applicant/get-ticket`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 获得企业认证审核记录信息
export async function authEnterpriseAuditDetails(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/enterprise/get-audit`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 企业信息变更
export async function enterpriseInfoChange(data) {
  return await http.put(`${BASE_NAME}/member/enterprise/change`, data);
}

// 认领人变更
export async function claimantChange(data) {
  return await http.put(`${BASE_NAME}/member/enterprise/claimant-change`, data);
}

// 获取认领人列表
export async function getClaimantList(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/role-auth/get-list`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 职员角色管理列表
export async function getStaffManageList(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/role-auth/manage/page`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 职员审核分页
export async function getStaffExamineList(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/role-auth/audit/page`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 移除职员
export async function deleteStaff(value) {
  try {
    const data = await http.delete(`${BASE_NAME}/member/role-auth/delete`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 职员审核-通过
export async function staffExaminePass(value) {
  try {
    const data = await http.post(`${BASE_NAME}/member/role-auth/audit/pass`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 职员审核-拒绝
export async function staffExamineReject(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/role-auth/audit/reject`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 角色认证-退出企业
export async function quitStaff(value) {
  try {
    const data = await http.get(`${BASE_NAME}/member/role-auth/quit`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// ==================== 企业课程资源相关接口 ====================

// 获取企业课程资源分页列表
export async function getCompanyCourseResourcePage(params) {
  try {
    const data = await http.get(`${BASE_NAME}/school/company-course-resource/page`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 获取企业课程授权职员学习明细分页
export async function getCompanyCourseAuthDetailPage(params) {
  try {
    const data = await http.get(`${BASE_NAME}/school/company-course-resource/auth-detail/page`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

// 导出企业课程授权职员学习明细 Excel
export async function exportCompanyCourseAuthDetail(params) {
  return await http.get(`${BASE_NAME}/school/company-course-resource/auth-detail/export-excel`, {
    params,
    responseType: 'blob',
  });
}
